import { Col, Form, List, Radio, Row, Typography } from "antd";
import React from "react";
import { DislikeOutlined, LikeOutlined } from "@ant-design/icons";
import { memoryFieldsOptions } from "../../../../Options/physioOptions";

const Memory = ({ psych = false }) => {
  return (
    <div
      className="moca-memory-outer"
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <List
        bordered={false}
        className="moca-section-card moca-memory-list"
        header={
          <Row
            style={{
              width: "100%",
              textAlign: "center",
            }}
            align="middle"
            gutter={[8, 8]}
          >
            <Col xs={0} sm={12}></Col>
            <Col xs={12} sm={6}>
              <Typography.Text strong className="moca-header-text">First Test</Typography.Text>
            </Col>
            <Col xs={12} sm={6}>
              <Typography.Text strong className="moca-header-text">Second Test</Typography.Text>
            </Col>
          </Row>
        }
        style={{
          width: psych === true ? "100%" : "600px",
          padding: "20px",
          maxWidth: "100%",
          margin: "0 auto",
        }}
        dataSource={memoryFieldsOptions}
        renderItem={(field) => (
          <List.Item className="moca-row">
            <Row
              style={{ width: "100%" }}
              align="middle"
              gutter={[8, 8]}
              wrap
            >
              {/* Label */}
              <Col xs={24} sm={12} style={{ textAlign: "center" }}>
                <Typography.Text>{field.label}</Typography.Text>
              </Col>

              {/* First Test */}
              <Col xs={12} sm={6}>
                <Form.Item
                  name={
                    psych === true
                      ? ["moca", "memory_data", `${field.value}_1`]
                      : ["memory_data", `${field.value}_1`]
                  }
                  key={`${field.value}_1`}
                  style={{ marginBottom: 0, textAlign: "center" }}
                >
                  <Radio.Group style={{ width: "100%" }}>
                    <Row justify="center" gutter={[8, 0]} align="middle">
                      <Col>
                        <Radio.Button value="yes" className="like-btn">
                          <LikeOutlined />
                        </Radio.Button>
                      </Col>
                      <Col>
                        <Radio.Button value="no" className="dislike-btn">
                          <DislikeOutlined />
                        </Radio.Button>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </Col>

              {/* Second Test */}
              <Col xs={12} sm={6}>
                <Form.Item
                  name={
                    psych === true
                      ? ["moca", "memory_data", `${field.value}_2`]
                      : ["memory_data", `${field.value}_2`]
                  }
                  key={`${field.value}_2`}
                  style={{ marginBottom: 0, textAlign: "center" }}
                >
                  <Radio.Group style={{ width: "100%" }}>
                    <Row justify="center" gutter={[8, 0]} align="middle">
                      <Col>
                        <Radio.Button value="yes" className="like-btn">
                          <LikeOutlined />
                        </Radio.Button>
                      </Col>
                      <Col>
                        <Radio.Button value="no" className="dislike-btn">
                          <DislikeOutlined />
                        </Radio.Button>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </div>
  );
};

export default Memory;
